<template>
  <page-common type="normal" :showAppTopLink="isSharePage" :showAppBotLink="isSharePage" :detail="data">
    <h1 class="QA-subject" v-if="data" v-html="data.subject"></h1>
    <section class="QA-area" v-if="data">
      <div class="QQ-wrap">
          <!-- <div class="QQ-label">
              {{data.typeName}}
              <span class="status"> {{data.stateName}}</span>
          </div> -->
          <div class="QQ_header header-wrap flex flex-default flex-main-justify">
              <!-- <div>
                {{data.nickName}}
                问 {{data.leaderName}}
                </div>
              <div class="date">{{data.dateline && data.dateline.split(' ')[0]}}</div> -->
                <div class="flex flex-cross-center">
                    <div class="avatar" :style="{backgroundImage:`url(${data.avatar?data.avatar:icon})`}"></div>
                    <div class="info-area">
                        <div class="name ellipsis"> {{data.nickName}}</div>
                        <div class="time ellipsis">{{data.dateline}}</div>
                    </div>
                </div>
                <div :class="['like', 'flex', 'flex-cross-center',
                    data.stateName=='已回复'?'replied':data.stateName=='未回复'?'no_replied':''
                ]">
                   <!-- {{data.leaderName}}  -->
                </div>
          </div>

          
          <!-- <nav class="status">
              向
              <span class="questioner">银川发布</span> 提问
          </nav> -->
          <div :class="['content','font-size-'+fontSizeNum]" v-html="summaryReplace(data.content)"></div>
          <ul class="media-list" v-if="data.attachmentList">
            <li
              v-for="(item, index) in data.attachmentList"
              :key="index"
              :class="item.type == 'video'?'icon-video':''"
              @click="bigImage(item.type, item.imageUrl)"
            >
              <img :src="item.imageUrl">
            </li>
          </ul>
      </div>
      <div class='lines' v-if="data.asOrgName && data.asContent"></div>
      <div class="QA-wrap" v-if="data.asOrgName && data.asContent">
          <div class="QA-label">
              <label>- 反馈 -</label>
          </div>
          <i class='start'></i>
          <div class="contentDiv">
            <!-- <div class="gov_icon">
              <img src="~images/gov_icon.png">
            </div> -->
            <div>
                <!-- <i class='start'></i> -->
                <div :class="['content','font-size-'+fontSizeNum]" v-html="summaryReplace(data.asContent)"></div>
                <div class="header-wrap_as">
                  <!-- <div class="asOrgName">{{data.asOrgName}}</div> -->
                  <div class="date">{{data.asDateline}} <span class='ending'></span></div>
                <!-- <div class="date">{{data.questionTime && data.questionTime.split(' ')[0]}}</div> -->
                </div>
                
            </div>

          </div>
         
         
      </div>
      <!-- 分享 -->
      <!-- <div class="flex flex-default flex-main-around" v-if="!isSharePage">
          <span class="share-btn" @click="handleShare('wechat')">
              <img src="~images/icon-share-01.png">
              微信好友
          </span>
          <span class="share-btn" @click="handleShare('wechatmoments')">
              <img src="~images/icon-share-02.png">
              朋友圈
          </span>
          <span class="share-btn" @click="handleShare('sina')">
              <img src="~images/icon-share-03.png">
              微博
          </span>
      </div> -->
       <!-- 锦观 -->
      <div class="content-footer"></div>
      <!-- 相关信息 -->
      <ul class="article-desc">
          <li>未经授权，严禁转载</li>
          <li>联系电话：028-86751128</li>
      </ul>
      <div class="comment" v-if="comments !== null && comments.length > 0">
        <div class="title" v-if="comments.length > 0">
            <i></i>
            <span>热门评论</span>
        </div>
        <div v-if="comments.length > 0">
          <ul>
            <li :key="index" v-for="(item, index) in comments" @click="addComment(item)">
              <header class="flex flex-cross-center flex-main-justify">
                  <div class="flex flex-cross-center">
                      <div class="avatar" :style="{backgroundImage:`url(${item.userIcon?item.userIcon:icon})`}"></div>
                      <div class="info-area">
                          <div class="name ellipsis">{{item.username}}</div>
                          <div class="time ellipsis">{{getTime(item.date)}}</div>
                      </div>
                  </div>
                  <div class="like flex flex-cross-center" @click.stop="setActiveLike(item)">
                      
                    <span :class="[item.isLike?'active-num':'num']">{{getLikesCount(item.likes+'')}}</span>
                    <i :class="[item.isLike?'active-good':'good']"></i>
                      
                  </div>
              </header>
              <section>
                  <p v-html="item.content"></p>
              </section>
              <div class="origin" v-if="item.parent">
                  
                      <div class="origin-name">{{item.parent.username}}</div>
                 
                  <div class="origin-time">{{getTime(item.parent.date)}}</div>
                  <div class="origin-content">
                      {{item.parent.content}}
                  </div>
              </div>
            </li>
          </ul>
          <div v-if="!isSharePage && comments.length >= 5" class="check-all" @click="appPostMessage('checkAllComment')">查看全部评论 <i></i></div>
          <div v-else-if="!isSharePage && comments.length > 0 && comments.length < 5" class="show-all">已显示全部内容</div>
        </div>
      </div>
  </section>
  </page-common>
</template>

<script>
import Vue from 'vue'
import api from 'src/constants/appapi'
import PageCommon from './page-common'
import { intfc_prefix_common } from 'constants/project'
import wx from '../services/weChatShare'
import icon from 'src/images/mine_avatar.png'
export default {
  name: '',
  props: {},
  data() { return {
    icon,
    data: null,
    fontSizeNum: 3,
    isPreviewPage: false,
    isSharePage: false,
    comments: null, // 评论内容
    mockLikes: [], // 点赞数组
  } },
  computed: {},
  watch: {
    comments: {
      handler () {},
      deep: true
    }
  },
  created() {
     // 暴露方法给webview
        window.appapi = api
        window.$vm = this
        // 设置字体大小
        appapi.changeFontSize(this.$route.query.fontsize)
        this.isPreviewPage = appapi.isPreviewPage()
        this.isSharePage = appapi.isSharePage()
        const govDetailId = this.$route.params.id
        this.getInit(govDetailId)
       
  },
  mounted() {},
  methods: {
    summaryReplace(str) {
        return str.replace(/\n/g,"<br/>")
    },
    handleShare(taget) {
        this.appPostMessage('doShare',taget)
    },
    getInit(govDetailId){
      this.$axios.get(`${intfc_prefix_common}/api/v2/threads/getThreadsById/${govDetailId}`)
        .then(res=>{
            if(res.code ==0){
                this.data = res.item
                this.getComment(this.data.sysCode,govDetailId)
                this.appPostMessage('renderFinish','')
                wx({
                    title: this.data.subject,
                    imgUrl: this.data.shareImage || '',
                    // imgUrl: imgUrl || cover || '',
                    // desc: val.description || ''
                },this)
            }
            
            // console.log('1111',res)
        })
    },
    getComment(sysCode,articleId){
      this.$axios.get(`${intfc_prefix_common}/api/comments/${sysCode}/${articleId}?size=5`)
        .then(res => {
            const result = res.items
            if (res.code === 0) {
                console.log(this.comments !== null && this.comments.length > 0);
                if (result) {
                    this.comments = result
                    this.comments.map(item => {
                        item.isLike = false
                    })
                    this.handleLikes(this.mockLikes)
                }else {
                    this.comments = []
                }
            }
        })
        .catch(e => {
            console.log(e);
        })
    },
    handleLikes (arr){
      console.log(arr,'arr')
      if (arr && arr.length > 0) {
        this.mockLikes = arr
        this.mockLikes.map((item) => {
            this.$forceUpdate();
            this.comments.map((option) => {
              console.log(item,option.id,'dfdfd')
                if (item === option.id) {
                    option.isLike = true
                }
            })
        })
      }
    },
    addComment (item) {
        if (!item.id) return
        this.appPostMessage('comment',JSON.stringify(item))
    },
    setActiveLike (opt) {
            if (this.isSharePage || !opt.id) return
            this.$forceUpdate();
            if (!opt.isLike) {
                this.appPostMessage('phraise',JSON.stringify(opt))
                this.comments.map((option) => {
                    if (opt.id === option.id) {
                        option.isLike = true
                        option.likes += 1
                    }
                })
            }
        },
     getLikesCount (count) {
        let result = ''
        if (count > 0) {
            result = count
            if (count > 999999) {
                result = count.substring(0,count.length - 4) + '万'
                if (count > 99999999) {
                    result = '过亿'
                }
            }
        }
        return result
    },
    getTime (time) {
      let result = ''
      if (time) {
          result = time.substring(0,10) + ' ' + time.substring(11,16)
      }
      return result
    },
    bigImage(type, imageUrl) {
      if(this.isSharePage){
        $('a#openApp')[0].click()
      }
      let urls=[];
      let videoUrl='';
      this.data.attachmentList.forEach(item => {
        if (item.type == 'image'){
          urls.push(item.url)
        } else if (item.type == 'video'){
          videoUrl = item.url
        }
      })
      console.log(urls,videoUrl)
      if(type == 'image'){
        let index = urls.indexOf(imageUrl)
        let obj = JSON.stringify({ position: index, urls})
        this.appPostMessage('checkBigPic', obj)
      } else {
        let obj = JSON.stringify({ videoUrl, videoTitle: '' })
        this.appPostMessage('watchVideo', obj)
      }
    },
    appPostMessage (name, value='') {
      // 调用app原生方法
      if (name) window.appapi.appPostMessage(name, value)
    },
  },
  filters: {},
  components: {
    PageCommon,
  }
}
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
  @import "~src/stylus/mixin";
  @import '~src/stylus/detail/QA';
  .QA-subject
    padding 20px 30px 20px
    font-weight 400
    font-size 44px
    line-height 68px
    color #222
    font-family: 'FZBIAOYSK','FZBIAOYSKIOS BOLD','PingFang SC', '微软雅黑', sans-serif;
  .QA-area
    font-family: 'FZBIAOYSK','FZBIAOYSKIOS BOLD','PingFang SC', '微软雅黑', sans-serif;
  .content
    margin-top -20px
    padding 0 30px
    text-align justify
    line-height 64px
    // line-height 1.8em
    word-break break-word
    font-family: 'FZBIAOYSK','FZBIAOYSKIOS','PingFang SC', '微软雅黑', sans-serif;
  ul.media-list{
    margin: 10px 30px 0;
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    align-items: flex-start;
    li {
      &.icon-video{
        position relative;
        &:after{
          content '';
          position absolute
          left: 112px;
          top: 70px;
          margin-left: -28px;
          margin-top: -8px;
          width 56px;
          height 56px;
          background: url("~images/btn-play-video.png") no-repeat 50% /100%;
          z-index 99
        }

      }
      img{
        margin-top: 20px;
        border-radius: 8px;
        width 224px;
        height 140px;
        margin-right 9px;
      } 

    } 
    li:nth-child(3n+3) img{
      margin-right 0;
    }
      
  }
  .comment
    margin-top 60px
    padding 30px
    //border-top 8px solid #F6F6F6;
    .title
      display flex
      align-items center
      span
        margin-left 10px
        color #222
        font-size 32px
        line-height 64px
        // font-weight bold
      i
        display inline-block
        width 48px
        height 48px
        background url("~images/icon_details_hot@2x.png") no-repeat 50%/100%
    ul 
      margin-top 88px
      font-family: 'FZBIAOYSK','FZBIAOYSKIOS','PingFang SC', '微软雅黑', sans-serif;
      li
        header
          display flex
          .avatar
            width 70px
            height 70px
            border-radius 999px
            background no-repeat 50%/100%
          .info-area
            max-width 460px
            height 70px
            text-indent 20px
            .name
              color #222
              font-size 28px
              line-height 40px
            .time
              color #666
              font-size 20px
              line-height 34px
              letter-spacing: 0.62px;
          .like
            height 70px
            i
              width 48px
              height 48px
              background no-repeat 50%/100%
            .good
              background-image url("~images/btn_good2x.png")
            .active-good
              background-image url("~images/btn_gooded2x.png")
            span
              margin-right 8px
              font-size 28px
            .num
              color #222
            .active-num
              color #E02829
        section
          margin-top 16px
          // margin-left 90px
          p
            overflow hidden
            word-break break-word
            line-height 56px
            font-size 32px
            color #000
      li:not(:first-of-type)
        margin-top 94px
    .check-all
      margin-top 98px
      padding-bottom 90px
      color #333333
      font-size 30px
      line-height 40px
      // justify-content center
      text-align center
      i
        display inline-block
        width 16px
        height 28px
        background url("~images/more.png") no-repeat 50%/100%
        vertical-align -4px
        margin-left 0px
    .show-all
      margin-top 98px
      padding-bottom 90px
      color #afafaf
      font-size 30px
      line-height 40px
      // justify-content center
      text-align center
      font-family: 'FZBIAOYSK','FZBIAOYSKIOS','PingFang SC', '微软雅黑', sans-serif;
    .origin
        margin-top 14px
        padding 24px 22px
        background #F6F6F6
        margin-left 90px
        .origin-name
          font-size 28px
          color #000000
          font-family: 'FZBIAOYSK','FZBIAOYSKIOS','PingFang SC', '微软雅黑', sans-serif;
        .origin-time
          margin-top 8px
          color #AFAFAF
          font-size 20px
        .origin-content
          margin-top 20px
          font-size 30px
          color #666666
          line-height 42px
          text-align justify
          overflow hidden
          word-break break-word
        .no-comment
          margin 40px auto 0
          width 560px
          height 560px
          background url("~images/no-comment.png") no-repeat 50%/100%
  .share-btn
    width 20%
    text-align center;
    font-size: 24px;
    line-height: 34px;
    color: #333;
    font-family: 'FZBIAOYSK','FZBIAOYSKIOS','PingFang SC', '微软雅黑', sans-serif;
    img
      display block
      width 64px;
      height 64px;
      margin 0 auto 20px
  .start
    display:block
    width: 24px;
    height: 20px;
    background:url("~images/start.png") no-repeat 50%/100%;
    margin-left:15px
  .contentDiv
    // display flex
    padding: 0 0.6rem;
    .content
      padding:0;
      font-size: 28px !important;
      color: #333333;
    .gov_icon
      img 
        width: 70px;
        height: 70px;
    .asOrgName
      color: #333333;
      font-size: 28px;
      padding-bottom:10px
    .header-wrap_as
      padding 0 0px 0px 0px;
      font-size: 24px;
      color: #888888;
      line-height: 34px;
      font-family: 'FZBIAOYSK','FZBIAOYSKIOS','PingFang SC', '微软雅黑', sans-serif;
    .date 
        min-width 150px
        color #666
        font-size 20px
        margin-top 10px
        overflow hidden
        .ending
          display: inline-block
          width: 24px;
          height: 20px;
          float:right;
          background:url("~images/ending.png") no-repeat 50%/100%;
          margin-top:6px
</style>




// WEBPACK FOOTER //
// page-government.vue?69ea9354